import _slicedToArray from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useRef, useState } from 'react';
export var useTooltipState = function useTooltipState() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$initialOpen = _ref.initialOpen,
      initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen;

  var _useState = useState(initialOpen),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hovered = _useState4[0],
      setHovered = _useState4[1];

  var wrapperRef = useRef(null);
  useEffect(function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var handleClose = function handleClose(e) {
      if (expanded && (e.target === window || wrapperRef.current && wrapperRef.current.contains && !wrapperRef.current.contains(e.target))) {
        setExpanded(false);
        setHovered(false);
        removeEventListener('click', handleClose);
        removeEventListener('focusin', handleClose);
        removeEventListener('blur', handleClose);
      }
    };

    if (wrapperRef.current && expanded) {
      addEventListener('click', handleClose);
      addEventListener('focusin', handleClose);
      addEventListener('blur', handleClose);
    }

    return function () {
      removeEventListener('click', handleClose);
      removeEventListener('focusin', handleClose);
      removeEventListener('blur', handleClose);
    };
  }, [expanded]);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Esc' || e.key === 'Escape') {
      setExpanded(false);
    }
  };

  var toggleExpanded = function toggleExpanded() {
    setExpanded(!expanded);
    setHovered(false);
  };

  return {
    expanded: expanded,
    handlers: {
      onKeyDown: handleKeyDown,
      onClick: function onClick() {
        return setExpanded(true);
      },
      onFocus: function onFocus() {
        return setExpanded(true);
      },
      onMouseEnter: function onMouseEnter() {
        return setHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovered(false);
      }
    },
    hovered: hovered,
    open: expanded || hovered,
    setExpanded: setExpanded,
    setHovered: setHovered,
    toggleExpanded: toggleExpanded,
    wrapperRef: wrapperRef
  };
};